import { Navigate } from 'react-router';
import { Spinner } from '../ui';
import { useAuth } from '../auth/AuthProvider';
import { LandingPage } from './landing/LandingPage';

/**
 * The landing route.
 *
 * An authenticated user is taken straight to their garage — the home of the app is their own data,
 * not a profile page. While sign-in is still resolving it shows a spinner rather than a protected
 * call that would 401 mid-redirect. A signed-out visitor gets the full marketing landing. In
 * development mode the identity is always present, so this resolves immediately to the garage.
 *
 * @returns The landing element.
 */
export function HomePage(): React.JSX.Element {
  const { status } = useAuth();

  if (status === 'loading') {
    return (
      <main id="main" style={{ minHeight: '100dvh', display: 'grid', placeItems: 'center' }}>
        <Spinner label="Loading Greasemap" />
      </main>
    );
  }

  if (status === 'authenticated') {
    return <Navigate to="/garage" replace />;
  }

  return <LandingPage />;
}
